import React from 'react';
import { EventTypeInput } from '../../../types/ViewModel/EventTypeInput';
import eventInputUtils from '../../../utils/event/eventInputUtils';
import TextareaAutosize from 'react-textarea-autosize';
import { InputWrapper, InputHeadingWrapper, InputFieldWrapper, ValidationWrapper } from '../EventInput.styles';
import { resolveHeading } from '../../../utils/event/headingOverrides';

type Props = {
    onChange: (ev: string | null, key: number, isEmpty: boolean, isValid: boolean) => void;
    evTypeInput: EventTypeInput;
    seqNr: number;
    key: string;
};

const StringInputComponent: React.FC<Props> = (props) => {
    const { isStringInputValid, getMaxCharStr } = eventInputUtils();

    const inputHandler = (strEvent: string | null) => {
        const valid = isStringInputValid(props.evTypeInput, strEvent ?? null);
        props.onChange(strEvent ?? null, props.evTypeInput.eventTypeInputId, !strEvent || strEvent.length === 0, valid);
    };

    const checkIsValid = (evTypeInp: EventTypeInput, str: string | null): boolean => {
        return isStringInputValid(evTypeInp, str);
    };

    const getKey = () => {
        return props.evTypeInput.eventTypeInputId + '-' + props.seqNr;
    };

    const getValue = (): string => {
        if (props.evTypeInput.eventTypeInputReg) {
            if (props.evTypeInput.eventTypeInputReg.stringValueReg !== undefined) {
                return props.evTypeInput.eventTypeInputReg.stringValueReg ?? '';
            }
        }
        return '';
    };

    const getName = (): string => {
        return props.evTypeInput.eventTypeInputId.toString() + '-' + props.seqNr.toString();
    };

    return (
        <InputWrapper>
            <InputHeadingWrapper>{resolveHeading(props.evTypeInput)}</InputHeadingWrapper>
            <InputFieldWrapper>
                <ValidationWrapper isValid={checkIsValid(props.evTypeInput, getValue() ?? null)}>
                    <TextareaAutosize
                        name={getName()}
                        className="input"
                        hidden={false}
                        key={getKey()}
                        value={getValue()}
                        required={props.evTypeInput.inputMandatory}
                        onChange={(e) => inputHandler(e.target.value)}
                        maxLength={getMaxCharStr()}
                    />
                </ValidationWrapper>
            </InputFieldWrapper>
        </InputWrapper>
    );
};

export default StringInputComponent;
